module.exports = __webpack_public_path__ + "img/logo_shine_digital_couleur_noir.85e05910.png";